import React from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { IconSpinner } from '../../../components';

import css from './SaveSearchButton.module.css';

// Simple bookmark glyph: outline when unsaved, filled when saved.
const BookmarkIcon = ({ filled }) => (
  <svg
    className={css.icon}
    width="14"
    height="16"
    viewBox="0 0 14 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 1.5h9a1 1 0 0 1 1 1v11.6a.4.4 0 0 1-.62.33L7 12.2l-4.88 2.23A.4.4 0 0 1 1.5 14.1V2.5a1 1 0 0 1 1-1z"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
);

const SaveSearchButton = props => {
  const {
    rootClassName,
    className,
    isSaved,
    inProgress,
    disabled,
    onClick,
  } = props;

  const classes = classNames(rootClassName || css.root, className, {
    [css.saved]: isSaved,
  });

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={disabled || inProgress}
      aria-pressed={isSaved}
    >
      {inProgress ? (
        <IconSpinner className={css.spinner} />
      ) : (
        <BookmarkIcon filled={isSaved} />
      )}
      <span className={css.label}>
        <FormattedMessage
          id={isSaved ? 'SearchPage.savedSearch' : 'SearchPage.saveSearch'}
        />
      </span>
    </button>
  );
};

SaveSearchButton.defaultProps = {
  rootClassName: null,
  className: null,
  isSaved: false,
  inProgress: false,
  disabled: false,
};

SaveSearchButton.propTypes = {
  rootClassName: string,
  className: string,
  isSaved: bool,
  inProgress: bool,
  disabled: bool,
  onClick: func.isRequired,
};

export default SaveSearchButton;
